import css from "styled-jsx/css";

export const componentStyles = css.global`
  .asymmetric-side-by-side-text-and-asset-component {
    .asymmetric-side-by-side-text-and-asset-content {
      padding-bottom: 64px;
    }
  }
`;
